<template id="indexbody">
<a href="about.html" style="width:100%; height:100%;">
<section>
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="homeMain">
          <div class="homeContent">
            <h1 v-html="info.res.b2b">Sampson<br>
              Distribution Service </h1>
            <h3 v-html="info.res.headline">Great distribute. Great time.</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</a>
</template>

<script>
export default {
  name: 'indexbody',
  props:['name', 'info', 'title'],
  data () {
    return {
      "res":null
    }
  },
  mounted: function() {
    if (this.info != null) {
      this.res = this.info.res;
    }
    $('#title').html(this.title);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IndexBody.vue